(function() {
  const paralaxModule = $('.animateParalaxModule');
  const descriptionText = $('.animateParalaxModule__description p');
  const paralax = $('.animateParalaxModule__wrapper');

  $.jScrollability([
    {
      'selector': paralaxModule,
      'start': function($el) { return $el.offset().top + window.innerHeight },
      'end': function($el) { return $el.offset().top + $el.height() },
      'fn': function($el, pcnt) {
        let paralaxScale = 300;
        let speedScale = 1.2;

        if (window.innerWidth <= 960) {
          paralaxScale = 600;
          speedScale = 1.5;
        }

        paralax.css({
          'background-position-y': `${-((pcnt * speedScale) * paralaxScale)}px`,
        });

        descriptionText.each(function(i) {
          const opacityScale = (i + 1) / 10;

          if (pcnt >= 0.3) {
            $(this).css({'opacity': `${(((pcnt - 1) * (1.5 + opacityScale)) + 1) * 2}`,});
          } else {
            $(this).css({'opacity': '0',});
          }
        });
      }
    }
  ]);
}());
